module.exports = __webpack_public_path__ + "static/media/rebate-sticker.24461f8a.gif";